module.exports = __webpack_public_path__ + "static/media/pra-sejahtera.d49cee87.jpg";